import {hasAccess} from "@/libs/userAbility/userAbilityChecker";
import Cookie from 'js-cookie';

import IAccessToken from '@/interfaces/IAccessToken';
import getCookieDomain from '@/libs/domain/getCookieDomain';
import store from '@/store/index';

const isAuthenticated = (): IAccessToken | null => {
    // const tokenFromCookie = Cookie.get('access_token', {
    //     domain: getCookieDomain()
    // });

    const token = localStorage.getItem('access_token');

    if (store.state.access_token) {
        return store.state.access_token;
    } else {
        // @ts-ignore
        store.state.access_token = token;
    }

    return store.state.access_token;
};

// Is Authenticated
const checkAuth = (to: object, from: object, next: any) => {
    if (!isAuthenticated()) {
        next('/auth');
    }
    next();
};

// Isn't Authenticated
const checkRoute = (to: any, from: any, next: any) => {
    if (to.path === '/auth' && !!isAuthenticated()) {
        next('/');
    }
    next();
};

// Is user ability
const checkUserAccess = (role:string) => {
    const roles = store.getters.profile.allRoles;
    console.log('checler', role, roles);
    return hasAccess(role, roles);
};
// const checkUserAccess = (to, from, next) => {
//     const grantedByRole = to.matched.some(record => {
//         return checkUserAccess(record.meta.accessLevel);
//     });
//
//     if (to.matched.some(record => record.meta.public || record.meta.guest || grantedByRole)) {
//         next();
//     } else {
//         notify({
//             title: 'Errors.accessError',
//             type: 'error',
//             delay: 5000
//         });
//         next({ path: from.path });
//     }
// };

// Save to Clipboard
function saveParamsToClipboard() {
    const text = store.state.access_token;
    const getSelection: any = window.getSelection()
    getSelection.removeAllRanges();
    const em = document.createElement('em');
    em.classList.add('paramsData');
    em.style.opacity = '0';
    em.style.position = 'absolute';
    em.style.top = '-9999px';
    document.body.insertBefore(em, document.body.firstChild);
    const params: any = document.querySelector('.paramsData');
    params.innerText = text;
    const range = document.createRange();
    range.selectNode(params);
    getSelection.addRange(range);

    try {
        document.execCommand('copy');
        const successful = document.execCommand('copy');
        successful ? alert('successful') : alert('unsuccessful');
    } catch (err) {
        console.log('Oops, unable to copy');
    }
}

// Token to Clipboard
const tokenToClipboard = () => {
    let tabIsPressed = false;

    window.addEventListener('keydown', (event) => {
        if (event.keyCode === 9) {
            tabIsPressed = true;
            event.preventDefault();
        }
    });

    window.addEventListener('keyup', (event) => {
        if (event.keyCode === 9) {
            tabIsPressed = false;
            event.preventDefault();
        }
    });

    window.addEventListener('keydown', (event) => {
        if (tabIsPressed && event.keyCode === 13) {
            event.preventDefault();
            saveParamsToClipboard()
            return;
        }
    });
};

export {isAuthenticated, checkAuth, checkRoute, tokenToClipboard, checkUserAccess}